/* NEO: Swap one Shopify video element between desktop and mobile uploads. */
(() => {
  if (window.neoLookbookResponsiveMediaInitialized) return;
  window.neoLookbookResponsiveMediaInitialized = true;

  const neo_mobileMedia = window.matchMedia('(max-width: 989px)');
  const neo_selector = '.lookbook__slide-video[data-neo-mobile-video-src]';

  const neo_syncVideo = (wrapper) => {
    const video = wrapper.querySelector('video');
    if (!video) return;

    const mode = neo_mobileMedia.matches ? 'mobile' : 'desktop';
    if (video.dataset.neoMediaMode === mode) return;

    const wasPlaying = !video.paused;
    const isClone = Boolean(video.closest('[data-neo-lookbook-clone="true"]'));
    const shouldAutoplay = wrapper.dataset.neoAutoplay === 'true' && !isClone;

    video.pause();
    video.autoplay = shouldAutoplay;

    if (mode === 'mobile') {
      video.src = wrapper.dataset.neoMobileVideoSrc;
      if (wrapper.dataset.neoMobileVideoPoster) {
        video.poster = wrapper.dataset.neoMobileVideoPoster;
      }
    } else {
      video.removeAttribute('src');
      if (wrapper.dataset.neoDesktopVideoPoster) {
        video.poster = wrapper.dataset.neoDesktopVideoPoster;
      }
    }

    video.dataset.neoMediaMode = mode;
    video.load();

    if ((wasPlaying || shouldAutoplay) && !isClone && !document.hidden) {
      video.play()?.catch(() => {});
    }
  };

  const neo_syncAll = (root = document) => {
    root.querySelectorAll(neo_selector).forEach(neo_syncVideo);
    requestAnimationFrame(() => {
      root.querySelectorAll('.lookbook__swiper').forEach((slider) => slider.swiper?.update());
      window.ScrollTrigger?.refresh();
    });
  };

  neo_syncAll();
  neo_mobileMedia.addEventListener('change', () => neo_syncAll());
  document.addEventListener('shopify:section:load', (event) => neo_syncAll(event.target));
})();
